import React, { Component } from 'react'
import { TwitterTimelineEmbed } from 'react-twitter-embed'
import './SocialFeed.css'

export default class SocialFeed extends Component {
    render() {
        return (
            <div className="SocialFeed">
                <h2 className="text-center">Social Feeds</h2>
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className="col-sm-6">
                            <TwitterTimelineEmbed 
                                sourceType="profile"
                                screenName="Boltapp_ng"
                                options={{ height: 400 }}
                            />
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
